import { rootState } from "../../types/rootState";

export const propsalsList = (s: rootState) => s.dataForOrder.banksList;

export const draftPropsalIds = (s: rootState) => s.dataForOrder.draftIds;
